import { SyncOutlined } from "@ant-design/icons";
import { Button } from "antd";
import * as React from "react";

interface Props {
  onClick: () => Promise<void>;
}
export const TableHeaderRefreshButton: React.FC<Props> = ({ onClick }) => {
  const [isLoading, setIsLoading] = React.useState(false);
  async function localOnClick() {
    setIsLoading(true);
    await onClick();
    setIsLoading(false);
  }

  return (
    <Button
      type="default"
      iconPosition="end"
      icon={<SyncOutlined />}
      onClick={localOnClick}
      loading={isLoading}
      disabled={isLoading}
    >
      Refresh
    </Button>
  );
};
